import {
  handleAuthFailure,
  isAuthFailureResponse,
} from "@stocai/api";
import { deleteUserCookie, setLogoutSignal } from "../utils";

const getStoredAccessToken = () => {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user?.access_token || null;
  } catch {
    return null;
  }
};

const normalizeBaseUrl = (baseUrl) => {
  if (!baseUrl) return "";
  return String(baseUrl).trim().replace(/\/+$/, "");
};

const resolveRequestUrl = (input) => {
  if (typeof input === "string") return input;
  if (input instanceof URL) return input.toString();
  if (input instanceof Request) return input.url;
  return "";
};

export const setupAuthFetch = () => {
  if (typeof window === "undefined" || typeof window.fetch !== "function") {
    return;
  }
  if (window.__stocaiAuthFetchPatched) return;

  const backendBaseUrl = normalizeBaseUrl(process.env.REACT_APP_BACKEND_API_URL);
  if (!backendBaseUrl) return;

  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    const url = resolveRequestUrl(input);
    if (!url || !url.startsWith(backendBaseUrl)) {
      return originalFetch(input, init);
    }

    const token = getStoredAccessToken();
    if (!token) {
      return originalFetch(input, init);
    }

    const mergedHeaders = new Headers(
      input instanceof Request ? input.headers : undefined
    );
    if (init?.headers) {
      const initHeaders = new Headers(init.headers);
      initHeaders.forEach((value, key) => mergedHeaders.set(key, value));
    }

    if (!mergedHeaders.has("Authorization")) {
      mergedHeaders.set("Authorization", `Bearer ${token}`);
    }

    const logoutExpiredSession = () => {
      setLogoutSignal();
      deleteUserCookie();
      handleAuthFailure();
    };

    const fetchWithAuth = async (nextInput, nextInit) => {
      const response = await originalFetch(nextInput, nextInit);
      if (response.ok) return response;

      let detail = "";
      try {
        const data = await response.clone().json();
        detail = data?.detail || "";
      } catch {
        detail = "";
      }

      if (isAuthFailureResponse(response.status, detail)) {
        logoutExpiredSession();
      }

      return response;
    };

    if (input instanceof Request) {
      const nextRequest = new Request(input, {
        ...init,
        headers: mergedHeaders,
      });
      return fetchWithAuth(nextRequest);
    }

    return fetchWithAuth(input, {
      ...init,
      headers: mergedHeaders,
    });
  };

  window.__stocaiAuthFetchPatched = true;
};

